import { call, get } from 'vuex-pathify';
export default {
  computed: {
    uldkAttributesMappings: get('search/uldkAttributesMappings'),
  },
  data: () => ({
    uldkAttributesFetched: false,
  }),
  methods: {
    getUldkAttributesMappings: call('search/getUldkAttributesMappings'),
    async init() {
      if (this.isAssignParcelVisible) {
        await this.getUldkAttributesMappings();
      }
      this.uldkAttributesFetched = true;
    },
  },
  mounted() {
    this.init();
  },
};
